import { gql } from "@apollo/client";

export const FETCH_MASTER_DATA = gql`
  query MasterData(
    $cultureCode: String!
    $passengerTypesEtag: String
    $titlesTypesEtag: String
    $contactTypesEtag: String
  ) {
    stations: resourceStations(query: { activeOnly: true, cultureCode: $cultureCode }) {
      __typename
      eTag
      expiration
      values {
        inActive
        allowed
        class
        cultureCode
        fullName
        locationDetails {
          cityCode
          countryCode
          timeZoneCode
          weightType
          coordinates {
            latitude
            longitude
          }
          zoneCode
          subZoneCode
          timeZoneCode
        }
        shortName
        fullName
        stationCode
        currencyCode
      }
    }
    cities: resourceCities(query: { activeOnly: true }) {
      expiration
      values {
        cityCode
        provinceStateCode
        countryCode
        name
        shortName
      }
    }
    passengerTypes: resourcePassengerTypes(
      query: { activeOnly: true, cultureCode: $cultureCode, eTag: $passengerTypesEtag }
    ) {
      values {
        allowed
        inActive
        maximumAge
        minimumAge
        name
        nonAdult
        passengerTypeCode
        typeIndicator
      }
    }

    titles: resourceTitles(query: { activeOnly: true, cultureCode: $cultureCode, eTag: $titlesTypesEtag }) {
      eTag
      expiration
      values {
        gender
        description
        titleKey
        weightCategory
      }
    }
    currencies: resourceCurrenciesv2(query: { activeOnly: true, cultureCode: $cultureCode, eTag: $contactTypesEtag }) {
      eTag
      expiration
      values {
        currencyCode
        description
        displayDigits
        displayPrefix
        displaySuffix
        inActive
        roundFactor
      }
    }
    documentTypes: resourceDocumentTypes(request: { activeOnly: true }) {
      values {
        documentTypeCode
        isExpirationDateRequired
        name
      }
    }
    country: resourceCountriesv2(query: { activeOnly: true }) {
      __typename
      expiration
      values {
        countryCode
        countryCode3C
        defaultCurrencyCode
        countryCode
        inActive
        name
      }
    }
  }
`;
